import {
  getOpportunityExportHistoryApi,
  getOpportunityExportStatusApi,
} from "../Apis/opportunityExport";
import {
  getOverviewOpportunityExportHistoryApi,
  getOverviewOpportunityExportStatusApi,
} from "../Apis/overviewOpportunityExport";
import {
  getPatientExportHistoryApi,
  getPatientExportStatusApi,
} from "../Apis/patientExport";
import { getTaskExportHistoryApi, getTaskExportStatusApi } from "../Apis/taskExport";
import type { GetOverviewExportHistoryResponse, GetOverviewExportStatusResponse } from "../Apis/overviewExportTypes";

export type ExportEntityType = "opportunities" | "patients" | "tasks";
export type ExportDataSource = "overview" | "configuration";

export function getExportStatusApi(
  entityType: ExportEntityType,
  source: ExportDataSource
): (exportId: string) => Promise<GetOverviewExportStatusResponse> {
  if (entityType === "patients") return getPatientExportStatusApi;
  if (entityType === "tasks") return getTaskExportStatusApi;
  if (source === "overview") return getOverviewOpportunityExportStatusApi;
  return async (exportId: string) => {
    const res = await getOpportunityExportStatusApi(exportId);
    return res as GetOverviewExportStatusResponse;
  };
}

export function getExportHistoryApi(
  entityType: ExportEntityType,
  source: ExportDataSource
): (params?: { limit?: number; offset?: number }) => Promise<GetOverviewExportHistoryResponse> {
  if (entityType === "patients") return getPatientExportHistoryApi;
  if (entityType === "tasks") return getTaskExportHistoryApi;
  if (source === "overview") return getOverviewOpportunityExportHistoryApi;
  return async (params) => {
    const res = await getOpportunityExportHistoryApi(params);
    return res as GetOverviewExportHistoryResponse;
  };
}

export function getExportEntityLabel(entityType: ExportEntityType): string {
  switch (entityType) {
    case "patients":
      return "patient";
    case "tasks":
      return "task";
    default:
      return "opportunity";
  }
}
